import { Form } from 'antd';
import React, { Suspense } from 'react';

import { LIST_TASK_GROUP_STATUS, LIST_TASK_STATUS } from '../../const';
import { IFieldBase } from '../../interfaces';
import ListItem from '../../outListItem';
import LoaderParentList from './loaderParentList';

const FieldStatusGrouping: React.FC<IFieldBase & { name: string; groupStatus?: boolean }> = ({
    name,
    disabled,
    groupStatus,
}) => {
    return (
        <>
            <Suspense>
                <LoaderParentList type={LIST_TASK_GROUP_STATUS} />
            </Suspense>
            <Form.Item label="Status" name={name}>
                <ListItem nameList={LIST_TASK_STATUS} disabled={disabled} group={groupStatus} />
            </Form.Item>
        </>
    );
};

export default React.memo(FieldStatusGrouping);
